import { render } from "./App.vue?vue&type=template&id=66bcbe3e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=66bcbe3e&lang=scss"

import exportComponent from "/Users/icer/Works/2105-chia/_cns/ChiaNameServiceSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__